module.exports = {"sectorTypes":["Border","Core","Task Force","Theatre Fleet"],"theatres":["Tailward","Central","Spinward","None/Other"]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/sectorDataFields.json
// module id = LvC0
// module chunks = 1